import BarChartIcon from '@material-ui/icons/BarChart';
import CalendarTodayIcon from '@material-ui/icons/CalendarTodayOutlined';
import ChatIcon from '@material-ui/icons/ChatOutlined';
import CodeIcon from '@material-ui/icons/Code';
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import FolderIcon from '@material-ui/icons/Folder';
import DashboardTwoToneIcon from '@material-ui/icons/DashboardTwoTone';
import GradeTwoTone from '@material-ui/icons/GradeTwoTone';
import ListAltIcon from '@material-ui/icons/ListAlt';
import LockOpenIcon from '@material-ui/icons/LockOpenOutlined';
import MailIcon from '@material-ui/icons/MailOutlined';
import PresentToAllIcon from '@material-ui/icons/PresentToAll';
import PeopleIcon from '@material-ui/icons/PeopleOutlined';
import PersonIcon from '@material-ui/icons/PersonOutlined';
import ReceiptIcon from '@material-ui/icons/ReceiptOutlined';
import SettingsIcon from '@material-ui/icons/SettingsOutlined';
import ViewModuleIcon from '@material-ui/icons/ViewModule';
import DescriptionIcon from '@material-ui/icons/Description';

import { ReactComponent as HomeSvg } from '../../assets/images/icons/house-solid-full.svg';
import { ReactComponent as NewCaseSvg } from '../../assets/images/icons/dosar-nou.svg';
import { ReactComponent as DashboardsSvg } from '../../assets/images/icons/layout-dashboard.svg';
import { ReactComponent as FilesSvg } from '../../assets/images/icons/dosare.svg';
import { ReactComponent as EvaluationSvg } from '../../assets/images/icons/evaluare.svg';
import { ReactComponent as AgendaSvg } from '../../assets/images/icons/calendar-solid-full.svg';
import { ReactComponent as VehiclesHistorySvg } from '../../assets/images/icons/istoric-vehicule.svg';
import { ReactComponent as CarSideSvg } from '../../assets/images/icons/car-side-solid-full.svg';
import { ReactComponent as OrdersSvg } from '../../assets/images/icons/comenzi.svg';
import { ReactComponent as InvoiceHistorySvg } from '../../assets/images/icons/file-circle-check-solid-full.svg';
import { ReactComponent as ReportsSvg } from '../../assets/images/icons/chart-pie-solid-full.svg';
import { ReactComponent as NomenclaturesSvg } from '../../assets/images/icons/list-solid-full.svg';
import { ReactComponent as AdminSvg } from '../../assets/images/icons/user-shield-solid-full.svg';
import { ReactComponent as SettingsSvg } from '../../assets/images/icons/gear-solid-full.svg';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import { RoleClaimsEnum } from './../../helpers/Constants';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import BuildIcon from '@material-ui/icons/Build';
import CommuteOutlinedIcon from '@material-ui/icons/CommuteOutlined';
import React from "react";
import PowerBiLogo from '../../assets/images/power-bi-icon.png';
import EuroOutlinedIcon from '@material-ui/icons/EuroOutlined';

const svgIcon = (Svg) => ({ className }) => (
  <Svg className={className} width={24} height={24} />
);

const HomeIcon = svgIcon(HomeSvg);
const NewCaseIcon = svgIcon(NewCaseSvg);
const DashboardsIcon = svgIcon(DashboardsSvg);
const FilesIcon = svgIcon(FilesSvg);
const EvaluationIcon = svgIcon(EvaluationSvg);
const AgendaIcon = svgIcon(AgendaSvg);
const VehiclesHistoryIcon = svgIcon(VehiclesHistorySvg);
const CarSideIcon = svgIcon(CarSideSvg);
const OrdersIcon = svgIcon(OrdersSvg);
const InvoiceHistoryIcon = svgIcon(InvoiceHistorySvg);
const ReportsIcon = svgIcon(ReportsSvg);
const NomenclaturesIcon = svgIcon(NomenclaturesSvg);
const AdminIcon = svgIcon(AdminSvg);
const SettingsGearIcon = svgIcon(SettingsSvg);

const PowerBIIcon = ({ width = 24, height = 24 }) => {
  return (
    <img
      src={PowerBiLogo}
      alt="Power BI"
      width={width}
      height={height}
      style={{ objectFit: "contain" }}
      className='app-sidebar-icon'
    />
  );
};


var iconsMap = {
  BarChartIcon: BarChartIcon,
  CalendarTodayIcon: CalendarTodayIcon,
  ChatIcon: ChatIcon,
  CodeIcon: CodeIcon,
  DashboardIcon: DashboardIcon,
  ErrorIcon: ErrorIcon,
  FolderIcon: FolderIcon,
  DashboardTwoToneIcon: DashboardTwoToneIcon,
  GradeTwoTone: GradeTwoTone,
  ListAltIcon: ListAltIcon,
  LockOpenIcon: LockOpenIcon,
  MailIcon: MailIcon,
  PresentToAllIcon: PresentToAllIcon,
  PeopleIcon: PeopleIcon,
  PersonIcon: PersonIcon,
  ReceiptIcon: ReceiptIcon,
  SettingsIcon: SettingsIcon,
  ViewModuleIcon: ViewModuleIcon,
  HomeIcon: HomeIcon,
  LocalShippingIcon: LocalShippingIcon,
  DescriptionIcon: DescriptionIcon,
  DirectionsCarIcon: DirectionsCarIcon,
  AirportShuttleIcon: AirportShuttleIcon,
  BuildIcon: BuildIcon,
  CommuteOutlinedIcon: CommuteOutlinedIcon,
  PowerBIIcon: PowerBIIcon,
  EuroOutlinedIcon: EuroOutlinedIcon,
  NewCaseIcon: NewCaseIcon,
  DashboardsIcon: DashboardsIcon,
  FilesIcon: FilesIcon,
  EvaluationIcon: EvaluationIcon,
  AgendaIcon: AgendaIcon,
  VehiclesHistoryIcon: VehiclesHistoryIcon,
  CarSideIcon: CarSideIcon,
  OrdersIcon: OrdersIcon,
  InvoiceHistoryIcon: InvoiceHistoryIcon,
  ReportsIcon: ReportsIcon,
  NomenclaturesIcon: NomenclaturesIcon,
  AdminIcon: AdminIcon,
  SettingsGearIcon: SettingsGearIcon
};

export default [
  {
    label: '   ',
    content: JSON.parse(
      `[ 
    {
      "label": "Acasa",
      "tag": "MENU_HOME",
      "icon": "HomeIcon",
      "to": "/",
      "right": "${RoleClaimsEnum.Home}"
    },
    {
      "label": "Dosar nou",
      "tag": "MENU_NEW_CASE",
      "icon": "NewCaseIcon",
      "to": "/newCase",
      "right": "${RoleClaimsEnum.NewCase}"
    },
    {
      "label": "Dashboards",
      "tag": "MENU_DASHBOARDS",
      "icon": "DashboardsIcon",
      "to": "/dashboards",
      "right": "${RoleClaimsEnum.Dashboard}"
    },
    {
      "label": "Raport Power BI",
      "tag": "POWER_BI_REPORT",
      "icon": "PowerBIIcon",
      "description": "Raport Power BI",
      "to": "/power-bi/POWER_BI_ORDERS",
      "right": "${RoleClaimsEnum.PowerBi}"
    },
    {
      "label": "Dosare",
      "tag": "MENU_FILES",
      "icon": "FilesIcon",
      "to": "/cases",
      "right": "${RoleClaimsEnum.Case}"
    },
    {
      "label": "Evaluare",
      "tag": "EVALUATION",
      "icon": "EvaluationIcon",
      "to": "/valuation",
      "right": "${RoleClaimsEnum.Evaluation}"
    },
      {
      "label": "Agenda",
      "tag": "AGENDA",
      "icon": "AgendaIcon",
      "to": "/agenda",
      "right": "${RoleClaimsEnum.Agenda}"
    },
    {
      "label": "Vehicles History",
      "tag": "MENU_HISTORY_VEHICLES",
      "icon": "VehiclesHistoryIcon",
      "to": "/vehicles-history",
      "right": "${RoleClaimsEnum.Vehicle}"
    },
    {
      "label": "Vehicles",
      "tag": "MENU_VEHICLES",
      "icon": "CarSideIcon",
      "to": "/vehicles",
      "right": "${RoleClaimsEnum.Vehicle}"
    },
    {
      "label": "Comenzi",
      "tag": "MENU_ORDERS",
      "icon": "OrdersIcon",
      "to": "/orders",
      "right": "${RoleClaimsEnum.Order}"
    },
    {
      "label": "Raport MVO",
      "tag": "MENU_MVO_EXPORT_REPORT",
      "icon": "FolderIcon",
      "to": "/mvo-vehicles-export",
      "right": "${RoleClaimsEnum.ManagerMvo}"
    },
    {
      "label": "Mavo Vehicles",
      "tag": "MENU_MAVO_VEHICLES_RECORD",
      "icon": "CarSideIcon",
      "to": "/mavo-vehicles",
      "right": "${RoleClaimsEnum.MavoAdministrator}"
    },
    {
      "label": "Licitatii",
      "tag": "MENU_VO_AVAILABLE_AUCTIONS",
      "icon": "FolderIcon",
      "right": "${RoleClaimsEnum.MavoVehicle}",
      "rights" : ["${RoleClaimsEnum.MavoAgent}", "${RoleClaimsEnum.MavoAdministrator}"],
      "content": [
        {
          "label": "Licitatii active",
          "tag": "MENU_ACTIVE_AUCTIONS",
          "description": "Licitatii active",
          "to": "/auctions",
          "right": "${RoleClaimsEnum.MavoVehicle}",
          "rights" : ["${RoleClaimsEnum.MavoAgent}", "${RoleClaimsEnum.MavoAdministrator}"]
        },
        {
          "label": "Licitatiile mele",
          "tag": "MENU_USER_AUCTIONS",
          "description": "Licitatiile mele",
          "to": "/user/auctions",
          "right": "${RoleClaimsEnum.MavoVehicle}",
          "rights" : ["${RoleClaimsEnum.MavoAgent}"]
        },
        {
          "label": "Administrare licitatii",
          "tag": "MENU_ADMINISTRATION_AUCTIONS",
          "description": "Administrare licitatii",
          "to": "/admin/auctions",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        }
      ]
    },
    {
      "label": "Comenzi",
      "tag": "MENU_MAVO_ORDERS",
      "icon": "LocalShippingIcon",
      "to": "/mavo/orders",
      "right": "${RoleClaimsEnum.MavoVehicle}",
      "rights" : ["${RoleClaimsEnum.MavoAdministrator}"]

    },
    {
      "label": "Comenzile mele",
      "tag": "MENU_MAVO_USER_ORDERS",
      "icon": "LocalShippingIcon",
      "to": "/mavo/user/orders",
      "right": "${RoleClaimsEnum.MavoVehicle}",
      "rights" : ["${RoleClaimsEnum.MavoAgent}"]

    },
    {
      "label": "Istoric VO facturat",
      "tag": "MENU_VO_INVOICE_HISTORY",
      "icon": "InvoiceHistoryIcon",
      "to": "/invoice-history",
      "right": "${RoleClaimsEnum.MavoVehicle}",
      "rights" : ["${RoleClaimsEnum.MavoAgent}", "${RoleClaimsEnum.MavoAdministrator}", "${RoleClaimsEnum.MavoContab}"]
    },
    {
      "label": "Rapoarte",
      "tag": "MENU_REPORTS",
      "icon": "ReportsIcon",
      "right": "${RoleClaimsEnum.RaportComenzi}",
      "rights": ["${RoleClaimsEnum.RaportComenzi}", "${RoleClaimsEnum.ManagerComenziAP}", "${RoleClaimsEnum.Admin}", "${RoleClaimsEnum.ManagerExport}", "${RoleClaimsEnum.ManagerFacturare}", "${RoleClaimsEnum.Order}"],
      "content": [
    {
      "label": "Istoric Comanda Auto",
      "tag": "MENU_ORDER_PARTS_HISTORY",
      "to": "/order-parts-history",
      "right": "${RoleClaimsEnum.Order}"
    },
    {
      "label": "Raport Comenzi",
      "tag": "MENU_ORDERS_EXPORT_REPORT",
      "to": "/orders-export",
      "right": "${RoleClaimsEnum.RaportComenzi}",
      "rights": ["${RoleClaimsEnum.RaportComenzi}", "${RoleClaimsEnum.ManagerComenziAP}"]
    },
    {
      "label": "Facturi service-uri catre GTM",
      "tag": "MENU_REPAIR_SERVICE_TO_GTM_INVOICES_EXPORT_REPORT",
      "to": "/repair-service-invoices-export",
      "right": "${RoleClaimsEnum.Admin}",
      "rights": ["${RoleClaimsEnum.Admin}"]
    },
    {
      "label": "Raport raspuns furnizori",
      "tag": "MENU_SUPPLIER_ANSWER_REPORT",
      "to": "/supplier-response-report",
      "right": "${RoleClaimsEnum.RaportComenzi}"
    },
    {
      "label": "Raportare",
      "tag": "MENU_BILLING",
      "to": "/billing",
      "right": "${RoleClaimsEnum.ManagerExport}"
    },
    {
      "label": "Raportare facturare",
      "tag": "MENU_BILLING_CASE",
      "to": "/case-billing",
      "right": "${RoleClaimsEnum.ManagerFacturare}",
      "rights" : ["${RoleClaimsEnum.Admin}", "${RoleClaimsEnum.ManagerFacturare}"]
    },
    {
      "label": "Raportare DGPCI",
      "tag": "MENU_BILLING_DGPCI",
      "to": "/billing-dgpci",
      "right": "${RoleClaimsEnum.Admin}"
    },
    {
      "label": "Raportare WS",
      "tag": "MENU_BILLING_GT_WS",
      "to": "/billing-ws",
      "right": "${RoleClaimsEnum.Admin}"
    },
    {
      "label": "Raportare Piese Non Stoc",
      "tag": "MENU_BILLING_NON_STOCK_PART",
      "to": "/billing-non-stock",
      "right": "${RoleClaimsEnum.Admin}"
    },
    {
      "label": "Raportare Valuation",
      "tag": "MENU_BILLING_VALUATION",
      "to": "/billing-valuation",
      "right": "${RoleClaimsEnum.Admin}"
    }
      ]
    },
    {
      "label": "Nomeclatoare",
      "tag": "MENU_NOMENCLATURES",
      "icon": "NomenclaturesIcon",
      "right": "${RoleClaimsEnum.MavoAdministrator}",
      "rights" : ["${RoleClaimsEnum.MavoAdministrator}", "${RoleClaimsEnum.MavoContab}"],
      "content": [
        {
          "label": "Agent",
          "tag": "MENU_NOMENCLATURES_TAB_AGENT",
          "description": "Configurarea agentilor, a rolurilor si a permisiunilor.",
          "to": "/admin/mavo/users",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Organizatii",
          "tag": "MENU_ADMIN_TAB_ORGANIZATIONS",
          "description": "Adaugarea, stergerea, editarea si configurarea unei organizatii.",
          "to": "/admin/mavo/hoorganizations",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Versiune",
          "tag": "MENU_NOMENCLATURES_TAB_VERSION",
          "description": "Configurarea versiunilor",
          "to": "/nomenclature/version",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Culori",
          "tag": "MENU_NOMENCLATURES_TAB_COLOR",
          "description": "Configurarea culorilor",
          "to": "/nomenclature/color",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Caroserie",
          "tag": "MENU_NOMENCLATURES_TAB_BODY_TYPE",
          "description": "Configurarea caroseriei",
          "to": "/nomenclature/bodyType",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Stare componente",
          "tag": "MENU_NOMENCLATURES_TAB_BODY_CONDITION_TYPE",
          "description": "Configurare tipuri de stari caroserie",
          "to": "/nomenclature/bodyConditionType",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Stare roata",
          "tag": "MENU_NOMENCLATURES_TAB_WHEEL_CONDITION_TYPE",
          "description": "Configurare tipuri de stari roata",
          "to": "/nomenclature/wheelConditionType",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Parametri financiari",
          "tag": "MENU_NOMENCLATURES_TAB_FINANCIAL_PARAMETERS",
          "description": "Configurare Parametrii financiari",
          "to": "/nomenclature/financial-parameter",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Plaje avize/facturi",
          "tag": "MENU_NOMENCLATURES_TAB_INVOICE_RANGE",
          "description": "Configurare Plaje avize/facturi",
          "to": "/nomenclature/invoice-range",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Provenienta",
          "tag": "MENU_NOMENCLATURES_TAB_PROVENANCE",
          "description": "Configurare Provenienta",
          "to": "/nomenclature/provenance",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Curs valutar",
          "tag": "MENU_NOMENCLATURES_TAB_CURRENCY",
          "description": "Configurare Curs valutar",
          "to": "/nomenclature/currency",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        },
        {
          "label": "Erori",
          "tag": "MENU_NOMENCLATURES_TAB_ALCOR_ERROR",
          "description": "Alcor Error",
          "to": "/nomenclature/alcor-error-log",
          "right": "${RoleClaimsEnum.MavoVehicle}",
          "rights" : ["${RoleClaimsEnum.MavoAdministrator}", "${RoleClaimsEnum.MavoContab}"]
        },
        {
          "label": "Parametrare Alcor",
          "tag": "MENU_NOMENCLATURES_TAB_ALCOR_PARAMETERS",
          "description": "Parametrare Alcor",
          "to": "/nomenclature/alcor-parameters",
          "right": "${RoleClaimsEnum.MavoVehicle}",
          "rights" : ["${RoleClaimsEnum.MavoAdministrator}", "${RoleClaimsEnum.MavoContab}"]
        },
        {
          "label": "Date vanzator",
          "tag": "MENU_NOMENCLATURES_TAB_SELLER_DATA",
          "description": "Configurare date vanzator",
          "to": "/nomenclature/seller-data",
          "right": "${RoleClaimsEnum.MavoAdministrator}"
        }
      ]
    },
    {
      "label": "Admin",
      "tag": "MENU_ADMIN",
      "icon": "AdminIcon",
      "right": "${RoleClaimsEnum.Admin}",
      "rights" : ["${RoleClaimsEnum.Admin}", "${RoleClaimsEnum.AdminCountryOrganization}", "${RoleClaimsEnum.AdminService}", "${RoleClaimsEnum.Dealer}"],
      "content": [
        {
          "label": "Coeficient curs valutar",
          "tag": "MENU_EXCHANGE_RATE_COEFFICIENT",
          "description": "Coeficient curs valutar",
          "to": "/exchange-rate-coefficient",
          "right": "${RoleClaimsEnum.Dealer}",
          "rights": ["${RoleClaimsEnum.Admin}", "${RoleClaimsEnum.Dealer}"]
        },
        {
          "label": "Utilizatori",
          "tag": "MENU_ADMIN_TAB_USERS",
          "description": "Configurarea utilizatorilor, a rolurilor si a permisiunilor.",
          "to": "/admin/users",
          "right": "${RoleClaimsEnum.AdminUsers}"
        },
        {
          "label": "Liste de valori",
          "tag": "MENU_ADMIN_TAB_LIST_OF_VALUES",
          "description": "Adaugarea, stergerea si modificarea listelor de valori.",
          "to": "/admin/listOfValues",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Alte liste de valori",
          "tag": "MENU_ADMIN_TAB_OTHER_LIST_OF_VALUES",
          "description": "Adaugarea, stergerea si modificarea altor listelor de valori.",
          "to": "/admin/otherListOfValues",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Modele",
          "tag": "NOMENCLATURE_MODEL_LIST",
          "description": "Modele",
          "to": "/admin/model-car-class",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Preturi inchiriere/zi",
          "tag": "CAR_CLASS_RENTAL_PRICE",
          "description": "Preturi inchiriere/zi",
          "to": "/admin/car-class-rent-price",
          "right": "${RoleClaimsEnum.Admin}"
        },
        {
          "label": "Cupi piese fluxuri",
          "tag": "PART_OPTION_CUPI_CODE_LABEL",
          "description": "Cupi piese fluxuri",
          "to": "/admin/cupi-part-code",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Producatori top",
          "tag": "WORKFLOW_TOP_PRODUCER",
          "description": "Producatori top",
          "to": "/admin/top-producer",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Cupi Piese Optionale Revizie",
          "tag": "MAINTENANCE_CUPI_PART_OPTIONAL",
          "description": "Cupi Piese Optionale Revizie",
          "to": "/admin/maintenance-cupi-part",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Categorii Mentenanta pe tara",
          "tag": "MAINTENANCE_CATEGORY_COUNTRY",
          "description": "Categorii Mentenanta pe tara",
          "to": "/admin/maintenance-category-based-country",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Producatori Mentenanta",
          "tag": "MAINTENANCE_PRODUCER",
          "description": "Producatori Mentenanta",
          "to": "/admin/maintenance-producer",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Mapari GT furnizori",
          "tag": "GT_SUPPLIER_MAPPING_TITLE",
          "description": "Mapari GT furnizori",
          "to": "/admin/gt-supplier-mapping",
          "right": "${RoleClaimsEnum.Admin}"
        },
        {
          "label": "Mapari publicari",
          "tag": "CLAIM_BOX_ADVERTISER_TITLE",
          "description": "Mapari publicari",
          "to": "/admin/claimbox-advertiser",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Tampon tari",
          "tag": "COUNTRY_BUFFER",
          "description": "Tampon tari",
          "to": "/admin/country-buffer",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Email-uri support pe tara",
          "tag": "COUNTRY_SUPPORT",
          "description": "Email-uri support pe tara",
          "to": "/admin/country-support",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Fluxuri configurabile pe tara",
          "tag": "MAINTENANCE_WORKFLOW_TITLE",
          "description": "Fluxuri configurabile pe tara",
          "to": "/admin/configurable-workflow",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Stock start dealeri",
          "tag": "DEALER_START_STOCK_TITLE",
          "description": "Stock start dealeri",
          "to": "/admin/dealer-start-stock",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "Rapoarte Power BI",
          "tag": "POWER_BI_REPORT_CONFIGURATION",
          "description": "Rapoarte Power BI",
          "to": "/admin/power-bi-reports",
          "right": "${RoleClaimsEnum.AdminValueList}"
        },
        {
          "label": "VQ Repo",
          "tag": "REPO_VQ_TITLE",
          "description": "VQ Repo",
          "to": "/admin/vq-repo-data",
          "right": "${RoleClaimsEnum.Admin}"
        },
        {
          "label": "Reimprospatare VIN",
          "tag": "VEHICLE_VQ_REQUERY_TITLE",
          "description": "Reimprospatare date VIN",
          "to": "/admin/vehicle-vq-requery",
          "right": "${RoleClaimsEnum.Admin}"
        },
        {
          "label": "VQ Repo",
          "tag": "MENU_ADMIN_VQ_REPO",
          "description": "VQ Repo",
          "to": "/admin/vq-repo",
          "right": "${RoleClaimsEnum.Admin}"
        },
        {
          "label": "XML",
          "tag": "MENU_ADMIN_TAB_XML",
          "description": "Download XML.",
          "to": "/admin/xml",
          "right": "${RoleClaimsEnum.Admin}"
        },
        {
          "label": "Organizatii",
          "tag": "MENU_ADMIN_TAB_ORGANIZATIONS",
          "description": "Adaugarea, stergerea, editarea si configurarea unei organizatii.",
          "to": "/admin/hoorganizations",
          "right": "${RoleClaimsEnum.AdminOrganization}",
          "rights" : ["${RoleClaimsEnum.AdminOrganization}", "${RoleClaimsEnum.AdminCountryOrganization}"]
        },        
        {
          "label": "Organizatia mea",
          "tag": "MENU_ADMIN_SERVICE_TAB_ORGANIZATIONS",
          "description": "Configurarea unei organizatii.",
          "to": "/admin/hoorganizations/",
          "right": "${RoleClaimsEnum.AdminService}"
        },
        {
          "label": "Poeditor",
          "tag": "MENU_ADMIN_TAB_POEDITOR",
          "description": "Poeditor",
          "to": "/admin/poeditor",
          "right": "${RoleClaimsEnum.Admin}",
          "rights" : ["${RoleClaimsEnum.Admin}", "${RoleClaimsEnum.AdminCountryOrganization}"]
        },
        {
          "label": "Legal documents",
          "tag": "FLEET_ADMIN_LEGAL_DOCUMENTS_LATERAL_MENU_TITLE",
          "description": "Legal documents",
          "to": "/admin/legal-documents",
          "right": "${RoleClaimsEnum.Admin}"
        }
      ]
      },
      {
        "label": "Setari",
        "tag": "MENU_SETTINGS",
        "icon": "SettingsGearIcon",
        "right": "${RoleClaimsEnum.Settings}",
        "rights" : ["${RoleClaimsEnum.Settings}", "${RoleClaimsEnum.UserAdminFurnizori}", "${RoleClaimsEnum.ConfiguratorExtradiscount}", "${RoleClaimsEnum.ManagerStockPropriu}"],
        "content": [
            {
              "label": "Interfete",
              "tag": "MENU_SETTINGS_TAB_INTERFACES",
              "description": "Configurarea utilizatorilor pentru interfetele organizatiei.",
              "to": "/settings/interfaces",
              "right": "${RoleClaimsEnum.Settings}"
            },
            {
              "label": "Piese stoc propriu",
              "tag": "MENU_SETTINGS_TAB_STOCK_PART",
              "description": "Configurare piese stoc propriu",
              "to": "/settings/stock-part",
              "right": "${RoleClaimsEnum.ManagerStockPropriu}"
            },
            {
              "label": "Furnizori",
              "tag": "MENU_SETTINGS_TAB_SUPPLIERS",
              "description": "Configurarea utilizatorilor pentru furnizorii organizatiei.",
              "to": "/settings/suppliers",
              "right": "${RoleClaimsEnum.UserAdminFurnizori}"
            },
            {
              "label": "Producatori furnizori",
              "tag": "MENU_SETTINGS_TAB_SUPPLIERS_PRODUCERS",
              "description": "Configurare producatori furnizori",
              "to": "/settings/producers",
              "right": "${RoleClaimsEnum.ConfiguratorExtradiscount}"
            },
            {
              "label": "Discounturi producatori furnizori",
              "tag": "MENU_SETTINGS_TAB_PRODUCERS_DISCOUNTS",
              "description": "Configurare discounturi producatori furnizori",
              "to": "/settings/producers-discounts",
              "right": "${RoleClaimsEnum.ConfiguratorExtradiscount}"
            }
          ]
          }  
]`,
      (key, value) => {
        if (key === 'icon') {
          return iconsMap[value];
        } else {
          return value;
        }
      }
    )
  }
];
